export default "__VITE_ASSET__5HqFJK4X__"